<template>
  <UiCopyright
    v-if="isDisplayed"
    :client-name="store.kiosk?.client_name ?? ''"
    :copyright-label="$t('Copyright.copyright')"
    :terms-label="$t('Copyright.terms')"
    :terms-link-label="$t('Copyright.termsLink')"
    :partner-title="visiblePartner?.title"
    :distribution-label="$t('Copyright.distribution')"
    @terms-click="onTermsClick"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { store } from '@/app/store';
import { useUiStore } from '@/app/stores/ui';
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiCopyright> in <template>
import { UiCopyright } from '@/ui-kit';

interface KioskPartner {
  id?: string;
  title?: string;
}

const HIDDEN_PARTNER_IDS = ['none', 'theartisan_ai'];

const ui = useUiStore();

const isDisplayed = computed(
  () => Boolean(store.kiosk?.client_name) && !ui.isStepContentHidden
);

const visiblePartner = computed<KioskPartner | null>(() => {
  const partner = store.kioskPartner as KioskPartner | null | undefined;
  if (!(partner?.id && partner?.title)) return null;
  if (HIDDEN_PARTNER_IDS.includes(partner.id)) return null;
  return partner;
});

function onTermsClick(): void {
  ui.showPrivacyPolicyPopup = true;
}
</script>
